"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[852],{

/***/ 4852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ area_OtherBankArea; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(3786);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
// EXTERNAL MODULE: ./src/components/common/modal/ModalBase.tsx + 1 modules
var ModalBase = __webpack_require__(790);
// EXTERNAL MODULE: ./src/components/common/text/Title.tsx
var Title = __webpack_require__(9657);
// EXTERNAL MODULE: ./src/components/common/button/SimpleButton.tsx
var SimpleButton = __webpack_require__(7960);
// EXTERNAL MODULE: ./src/components/common/text/Span.tsx
var Span = __webpack_require__(9329);
// EXTERNAL MODULE: ./src/styles/constants/color.ts
var color = __webpack_require__(5861);
// EXTERNAL MODULE: ./src/data/estimate/common/common.ts
var common = __webpack_require__(7512);
// EXTERNAL MODULE: ./src/lib/initObj.ts
var initObj = __webpack_require__(2251);
;// CONCATENATED MODULE: ./src/data/estimate/common/otherBank/list/atom.ts


/**
 *  탭당 요청한 타금융사 할부 메이커금융 상품 목록
 *  */ const otherBankMakerFinanceListState = (0,es/* atom */.cn)({
    key: "otherBankMakerFinanceList",
    default: (0,initObj/* INIT_LIST */.C$)()
});

;// CONCATENATED MODULE: ./src/data/estimate/common/otherBank/list/selector.ts



/**
 *  하나의 탭에 조회하려는 지불방법 목록
 * @param {number} id 조회할 탭 번호
 * @param {string} name 조회할 목록 이름
 * @return 탭당 name으로 선택한 지불방법 테이블 목록
 *  */ const otherBankListState = (0,es/* selectorFamily */.CG)({
    key: "otherBankList",
    get: (params)=>{
        return (param)=>{
            let { get  } = param;
            var ref;
            const { id , name  } = params;
            const tabId = id || ((ref = get(common/* tabState */.Ns).find((tab)=>tab.active)) === null || ref === void 0 ? void 0 : ref.id) || 1;
            switch(name){
                case "otherBankMakerFinance":
                    var ref1;
                    // 타금융사 할부 메이커금융 상품 목록
                    return (ref1 = get(otherBankMakerFinanceListState).find((item)=>item.id === tabId)) === null || ref1 === void 0 ? void 0 : ref1.list;
                default:
                    return undefined;
            }
        };
    }
});

// EXTERNAL MODULE: ./src/lib/common.ts
var lib_common = __webpack_require__(2940);
;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/table/row/OtherBankItemRow.tsx





/**
 *  타금융 할부목록 아이템 로우 컴포넌트
 * @param {OtherBank} item item
 * @param {boolean} openCm CM 펼치기 여부
 * @param {string} device pc or mobile
 * @param {function} onClick onClick
 *  */ function OtherBankItemRow(param) {
    let { item , openCm , device , onClick  } = param;
    const { name , monthlyPayment , totalInterest , cmPer , cmPrice , interestRate , cashback  } = item;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                onClick: ()=>onClick(item),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                    color: color/* ORANGE */.ud,
                    children: "적용"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                    children: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: device === "pc" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                    color: color/* DEEP_BLUE */.Ve,
                    children: (0,lib_common/* addComma */.oC)(Math.round(monthlyPayment), true)
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                            children: (0,lib_common/* addComma */.oC)(Math.round(totalInterest), true)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                            color: color/* DEEP_BLUE */.Ve,
                            children: (0,lib_common/* addComma */.oC)(Math.round(monthlyPayment), true)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: device === "pc" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                    children: (0,lib_common/* addComma */.oC)(Math.round(totalInterest), true)
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Span/* default */.Z, {
                            children: [
                                interestRate,
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Span/* default */.Z, {
                            children: [
                                cashback,
                                "%"
                            ]
                        })
                    ]
                })
            }),
            device === "pc" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Span/* default */.Z, {
                            children: [
                                interestRate,
                                "%"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Span/* default */.Z, {
                            children: [
                                cashback,
                                "%"
                            ]
                        })
                    })
                ]
            }),
            openCm && /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Span/* default */.Z, {
                        children: [
                            cmPer,
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Span/* default */.Z, {
                        children: [
                            "(",
                            (0,lib_common/* addComma */.oC)(Math.round(cmPrice), true),
                            ")"
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var row_OtherBankItemRow = (OtherBankItemRow);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/table/row/OtherBankItemDummyRow.tsx



/**
 *  타금융 할부목록 아이템 로우 컴포넌트
 * @param {boolean} openCm cm 펼치기 여부
 * @param {string} device pr or mobile
 *  */ function OtherBankItemDummyRow(param) {
    let { openCm , device  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                    children: "-"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                    children: "-"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                    children: "-"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                    children: "-"
                })
            }),
            device === "pc" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                            children: "-"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                            children: "-"
                        })
                    })
                ]
            }),
            openCm && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                    children: "-"
                })
            })
        ]
    });
}
/* harmony default export */ var row_OtherBankItemDummyRow = (OtherBankItemDummyRow);

// EXTERNAL MODULE: ./src/hooks/estimate/common/paymentWay/useCalculatorForPaymentWay.ts
var useCalculatorForPaymentWay = __webpack_require__(8078);
// EXTERNAL MODULE: ./src/data/estimate/common/otherBank/info/selector.ts
var selector = __webpack_require__(9421);
// EXTERNAL MODULE: ./src/hooks/common/useDevice.ts
var useDevice = __webpack_require__(9435);
;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/table/OtherBankTable.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 551px;\n  overflow-y: overlay;\n\n  @media (max-width: 768px) {\n    max-height: unset;\n    overflow-y: hidden;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 705px;\n  height: 551px;\n\n  border-top: 1px solid ",
        ";\n  border: 1px solid ",
        ";\n\n  & th,\n  & td {\n    height: 50px;\n    border-bottom: 1px solid ",
        ";\n    border-right: 1px solid ",
        ";\n  }\n\n  & th {\n    &:nth-of-type(6),\n    &:nth-of-type(7) {\n      width: 75px;\n    }\n  }\n\n  & td {\n    text-align: center;\n\n    &:first-of-type {\n      width: 65px;\n      cursor: pointer;\n    }\n\n    &:nth-of-type(2) {\n      background-color: #eaf5ff;\n    }\n\n    &:nth-of-type(3),\n    &:nth-of-type(4) {\n      width: 115px;\n    }\n\n    & > span {\n      display: block;\n    }\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n\n    & td {\n      &:first-of-type {\n        width: 40px;\n      }\n\n      &:nth-of-type(3) {\n        width: 75px;\n      }\n      &:nth-of-type(4) {\n        width: 80px;\n      }\n      &:nth-of-type(5) {\n        min-width: 60px;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}












const Base = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
const Table = emotion_styled_browser_esm/* default.table */.Z.table(_templateObject1(), color/* BLACK */.E5, color/* GRAY */.pF, color/* GRAY */.pF, color/* GRAY */.pF);
/**
 *  타금융사 할부 메이커금융 상품 목록 테이블 컴포넌트
 * @param {boolean} openCm CM 펼치기 여부
 * @param {function} closeEvent 모달 닫기 이벤트 함수
 *  */ function OtherBankTable(param) {
    let { openCm , closeEvent  } = param;
    // device
    const device = (0,useDevice/* default */.Z)();
    // select
    const targetTable = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "targetTable"
    }));
    // list
    const otherBankList = (0,es/* useRecoilValue */.sJ)(otherBankListState({
        name: "otherBankMakerFinance"
    }));
    const dummyList = Array.from({
        length: 10 - otherBankList.length
    });
    // function
    const { updateDefaultSettings  } = (0,useCalculatorForPaymentWay/* default */.Z)(targetTable);
    const onClick = (item)=>{
        const product = item.param;
        updateDefaultSettings(product, undefined, true);
        closeEvent();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Base, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table, {
            summary: "타금융사 할부 메이커금융 상품 목록 테이블",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                    fontSize: "15px",
                                    children: "상품명"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: device === "pc" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                    fontSize: "15px",
                                    children: "월납입금"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                            fontSize: "15px",
                                            children: "총 이자"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                            fontSize: "15px",
                                            children: "월납입금"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: device === "pc" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                    fontSize: "15px",
                                    children: "총 이자"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                            fontSize: "15px",
                                            children: "금리"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                            fontSize: "15px",
                                            children: "고객캐시백"
                                        })
                                    ]
                                })
                            }),
                            device === "pc" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                            fontSize: "15px",
                                            children: "금리"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                            fontSize: "15px",
                                            children: "고객캐시백"
                                        })
                                    })
                                ]
                            }),
                            openCm && /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                    fontSize: "15px",
                                    children: "CM"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                    children: [
                        !!otherBankList.length && otherBankList.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(row_OtherBankItemRow, {
                                item: item,
                                onClick: onClick,
                                openCm: openCm,
                                device: device
                            }, item.id)),
                        !!dummyList.length && dummyList.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(row_OtherBankItemDummyRow, {
                                openCm: openCm,
                                device: device
                            }, isNaN(item) ? Math.random() : -item))
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var table_OtherBankTable = (OtherBankTable);

// EXTERNAL MODULE: ./src/hooks/common/useSwitching.ts
var useSwitching = __webpack_require__(7532);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(196);
// EXTERNAL MODULE: ./src/hooks/estimate/common/useActiveTab.ts
var useActiveTab = __webpack_require__(1846);
// EXTERNAL MODULE: ./src/hooks/estimate/common/save/useSaveForNewcar.ts + 14 modules
var useSaveForNewcar = __webpack_require__(17);
;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/modal/CashbackConfirmModal.tsx

function CashbackConfirmModal_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto auto;\n  justify-items: center;\n  align-items: center;\n\n  & > h1,\n  & > span {\n    grid-column: span 2;\n  }\n\n  & > button {\n    width: 75px;\n    margin-top: 20px;\n  }\n"
    ]);
    CashbackConfirmModal_templateObject = function() {
        return data;
    };
    return data;
}











const CashbackConfirmModal_Base = emotion_styled_browser_esm/* default.div */.Z.div(CashbackConfirmModal_templateObject());
/**
 *  일시불 캐시백 신청 확인 모달 컴포넌트
 * @param {function} closeEvent 닫기 함수
 *  */ function CashbackConfirmModal(param) {
    let { closeEvent  } = param;
    // tab
    const { id  } = (0,useActiveTab/* default */.Z)();
    // hook
    const { getEstimateTitle , getSimple , getDetail  } = (0,useSaveForNewcar/* default */.Z)();
    const onClick = ()=>{
        (async ()=>{
            const returnArray = [];
            for(let i = 0; i < 3; i++){
                const index = i + 1;
                const isActive = index === id;
                const estimateTitle = getEstimateTitle(index);
                const simple = getSimple(index);
                const detail = getDetail(index);
                returnArray.push({
                    estimateTitle,
                    simple,
                    detail,
                    isActive
                });
            }
            const formData = new FormData();
            const config = {
                async: true,
                crossDomain: true,
                headers: {
                    "Content-Type": "multipart/form-data",
                    "cache-control": "no-cache"
                },
                processData: false,
                contentType: false,
                mimeType: "multipart/form-data"
            };
            formData.append("data", JSON.stringify(returnArray));
            const response = await axios/* default.post */.ZP.post("/newcar/api/set/estimate", formData, config);
            const estimateNo = (response === null || response === void 0 ? void 0 : response.data) || 0;
            const { protocol , host  } = window.location;
            // 오리지널 URL
            const originUrl = "/estimate/sharing".replace(/&/g, "%26").replace(/\+/g, "%2B");
            // 요청 URL
            const reqUrl = // `/new/car/estimate/url/make?originUrl=${originUrl}?simpleEstimateNo=${estimateNo}&ag=true&protocol=${protocol}//${host}/estimate/sharing/`.replace(
            "/new/car/estimate/url/make?originUrl=".concat(originUrl, "?simpleEstimateNo=").concat(estimateNo, "&protocol=").concat(protocol, "//").concat(host, "/estimate/sharing/").replace(/ /gi, "");
            await axios/* default.get */.ZP.get(reqUrl);
            await axios/* default.post */.ZP.post("/newcar/api/applyForLumpSumCashback?newEstimateNo=".concat(estimateNo)).then(()=>{
                alert("일시불 캐시백 신청이 완료되었습니다.");
                closeEvent();
            }).catch((err)=>{
                alert("신청이 실패하였습니다. 관리자에게 문의해주세요.");
                console.log("일시불캐시백 신청 에러 => ", err);
            });
        })();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBase/* default */.Z, {
        active: true,
        closeEvent: closeEvent,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CashbackConfirmModal_Base, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                    text: "일시불 캐시백 신청"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                    fontSize: "15px",
                    children: "일시불 캐시백을 신청하시겠습니까?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleButton/* default */.Z, {
                    text: "신청",
                    backgroundColor: color/* LIGHT_BLUE */.F3,
                    color: color/* WHITE */.Cj,
                    borderColor: color/* LIGHT_BLUE */.F3,
                    onClick: onClick
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleButton/* default */.Z, {
                    text: "취소",
                    onClick: closeEvent
                })
            ]
        })
    });
}
/* harmony default export */ var modal_CashbackConfirmModal = (CashbackConfirmModal);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/modal/CashbackModal.tsx

function CashbackModal_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n"
    ]);
    CashbackModal_templateObject = function() {
        return data;
    };
    return data;
}
function CashbackModal_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 90vw;\n  max-width: 900px;\n  overflow-y: overlay;\n  max-height: 75vh;\n\n  & > img {\n    height: 670px !important;\n    position: relative !important;\n  }\n\n  @media (max-width: 768px) {\n    width: 70vw;\n    max-width: 430px;\n  }\n"
    ]);
    CashbackModal_templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  column-gap: 8px;\n  width: 240px;\n  height: 50px;\n  border-radius: 5px;\n  border: 0;\n  background-color: #ffde02;\n  padding: 0 20px;\n\n  & > span {\n    flex-grow: 1;\n  }\n\n  @media (max-width: 768px) {\n    width: 200px;\n\n    & > span {\n      font-size: 15px;\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}










const CashbackModal_Base = emotion_styled_browser_esm/* default.div */.Z.div(CashbackModal_templateObject());
const ImageWrapper = emotion_styled_browser_esm/* default.div */.Z.div(CashbackModal_templateObject1());
const Button = emotion_styled_browser_esm/* default.button */.Z.button(_templateObject2());
/**
 *  일시불캐시백 모달 컴포넌트
 * @param {function} closeEvent 닫기 함수
 *  */ function CashbackModal(param) {
    let { closeEvent  } = param;
    // device
    const device = (0,useDevice/* default */.Z)();
    const src = "/newcar/api/get/newOtherFinancialCashbackImg".concat(device === "mobile" ? "Mobile" : "");
    // switching
    const [confirmModal, switchingConfirm] = (0,useSwitching/* default */.Z)(false);
    // function
    const onClick = ()=>{
    // closeEvent();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBase/* default */.Z, {
                active: true,
                closeEvent: closeEvent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        text: "일시불 캐시백"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CashbackModal_Base, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: src,
                                    alt: "일시불 캐시백 테이블 이미지",
                                    sizes: "auto",
                                    fill: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
                                onClick: ()=>switchingConfirm(),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/assets/images/cashbackImg.png",
                                        alt: "캐시백 아이콘 이미지",
                                        width: 30,
                                        height: 30
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                        fontSize: "20px",
                                        fontWeight: "500",
                                        children: "일시불 캐시백 신청"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            confirmModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_CashbackConfirmModal, {
                closeEvent: ()=>switchingConfirm()
            })
        ]
    });
}
/* harmony default export */ var modal_CashbackModal = (CashbackModal);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/contents/OtherBankListContents.tsx

function OtherBankListContents_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    OtherBankListContents_templateObject = function() {
        return data;
    };
    return data;
}
function OtherBankListContents_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 8px;\n  justify-content: end;\n  align-items: center;\n  width: 100%;\n  height: auto;\n"
    ]);
    OtherBankListContents_templateObject1 = function() {
        return data;
    };
    return data;
}








const OtherBankListContents_Base = emotion_styled_browser_esm/* default.div */.Z.div(OtherBankListContents_templateObject());
const ButtonWrapper = emotion_styled_browser_esm/* default.div */.Z.div(OtherBankListContents_templateObject1());
/**
 *  타금융사 할부비교 할부목록 컨텐츠 컴포넌트
 * @param {function} closeEvent 모달 닫기 이벤트 함수
 *  */ function OtherBankListContents(param) {
    let { closeEvent  } = param;
    // state
    // 일시불 캐시백 모달 활성화 여부
    const [cashbackModal, switchingModal] = (0,useSwitching/* default */.Z)(false);
    // CM 펼치기 여부
    const [openCm, switchingCm] = (0,useSwitching/* default */.Z)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OtherBankListContents_Base, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleButton/* default */.Z, {
                                text: "일시불 캐시백",
                                color: color/* LIGHT_BLUE */.F3,
                                borderColor: color/* LIGHT_BLUE */.F3,
                                onClick: switchingModal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleButton/* default */.Z, {
                                text: "CM ".concat(openCm ? "접기" : "펼치기"),
                                onClick: switchingCm,
                                color: color/* LIGHT_BLUE */.F3,
                                borderColor: color/* LIGHT_BLUE */.F3
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(table_OtherBankTable, {
                        openCm: openCm,
                        closeEvent: closeEvent
                    })
                ]
            }),
            cashbackModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_CashbackModal, {
                closeEvent: switchingModal
            })
        ]
    });
}
/* harmony default export */ var contents_OtherBankListContents = (OtherBankListContents);

// EXTERNAL MODULE: ./src/styles/mixin/font.ts
var font = __webpack_require__(9960);
// EXTERNAL MODULE: ./src/components/common/radio/RadioLabel.tsx
var RadioLabel = __webpack_require__(9808);
// EXTERNAL MODULE: ./src/data/estimate/common/otherBank/info/atom.ts
var atom = __webpack_require__(7633);
// EXTERNAL MODULE: ./src/hooks/estimate/common/useUpdateInfo.ts
var useUpdateInfo = __webpack_require__(3226);
// EXTERNAL MODULE: ./src/api/estimate/common/paymentWay.ts
var paymentWay = __webpack_require__(7464);
// EXTERNAL MODULE: ./src/data/estimate/common/selectCar/info/selector.ts
var info_selector = __webpack_require__(9735);
// EXTERNAL MODULE: ./src/data/estimate/common/incidentalExpense/info/selector.ts
var incidentalExpense_info_selector = __webpack_require__(7030);
// EXTERNAL MODULE: ./src/data/estimate/common/tax/info/selector.ts
var tax_info_selector = __webpack_require__(1424);
// EXTERNAL MODULE: ./src/data/estimate/common/consignment/info/selector.ts
var consignment_info_selector = __webpack_require__(6461);
// EXTERNAL MODULE: ./src/data/estimate/common/paymentCharge/info/selector.ts
var paymentCharge_info_selector = __webpack_require__(7201);
// EXTERNAL MODULE: ./src/lib/estimate/common/otherBank/initObj.ts
var otherBank_initObj = __webpack_require__(1414);
;// CONCATENATED MODULE: ./src/lib/estimate/common/otherBank/refineList.ts

/**
 *  타금융사 할부 목록을 테이블에 뿌려지는 아이템 형태로 변환시켜주는 함수
 * @param {Trim} trim 트림정보
 * @param {number} registrationTotalPrice 등록합계
 * @param {number} totalPriceWithoutConsignmentPrice 합계-탁송료
 * @param {number} consignmentPrice 탁송료
 * @param {number} totalPriceWithConsignmentPrice 합계+탁송료
 * @param {number} taxInvoice 세금계산서(인도금대납반영전)
 * @param {number} deposit 계약금
 * @param {number} insuarancePremium 의무보험료
 * @param {number} period 기간
 * @param {number} advanceReceivedRate 선수율
 * @param {MakerFinance[]} productList 타금융사 할부 목록
 *  */ const refineOtherBankList = (param)=>{
    let { trim , registrationTotalPrice , totalPriceWithoutConsignmentPrice , consignmentPrice , totalPriceWithConsignmentPrice , taxInvoice , deposit , insuarancePremium , period , advanceReceivedRate , productList  } = param;
    if (!!!productList.length) {
        return [];
    }
    return productList.map((item)=>item && (0,otherBank_initObj/* getOtherBankItem */.Yv)(item, {
            trim,
            registrationTotalPrice,
            totalPriceWithoutConsignmentPrice,
            consignmentPrice,
            totalPriceWithConsignmentPrice,
            taxInvoice,
            deposit,
            insuarancePremium,
            period,
            advanceReceivedRate,
            productList
        }));
};

;// CONCATENATED MODULE: ./src/hooks/estimate/common/fetch/useFetchOtherBank.ts












/**
 *  타금융사 할부 목록 fetch custom hook
 *  */ function useFetchOtherBank() {
    // tab
    const { id  } = (0,useActiveTab/* default */.Z)();
    // set
    const setOtherBankMakerFinanceList = (0,es/* useSetRecoilState */.Zl)(otherBankMakerFinanceListState);
    // select
    // 브랜드
    const brand = (0,es/* useRecoilValue */.sJ)((0,info_selector/* selectCarInfoState */.s)({
        name: "brand"
    }));
    const brandNo = (brand === null || brand === void 0 ? void 0 : brand.brandNo) || 0;
    // 트림
    const trim = (0,es/* useRecoilValue */.sJ)((0,info_selector/* selectCarInfoState */.s)({
        name: "trim"
    }));
    const isHybrid = JSON.parse(trim === null || trim === void 0 ? void 0 : trim.isHybrid); // 하이브리드 여부
    const fuelType = (trim === null || trim === void 0 ? void 0 : trim.newFuelTypeName) || ""; // 연료종류(전기, 수소, 경유, 휘발유 등등)
    // 등록합계
    const registrationTotalPrice = (0,es/* useRecoilValue */.sJ)((0,incidentalExpense_info_selector/* incidentalExpenseInfoState */.w)({
        name: "registrationTotalPrice"
    }));
    // 합계(탁송료 제외)
    const totalPriceWithoutConsignmentPrice = (0,es/* useRecoilValue */.sJ)((0,tax_info_selector/* exemptionOrTaxationInfoState */.x)({
        name: "totalPriceWithoutConsignmentPrice"
    }));
    // 출고장
    const factory = (0,es/* useRecoilValue */.sJ)((0,consignment_info_selector/* consignmentPriceInfoState */.k)({
        name: "factory"
    }));
    // 탁송료 직접 입력
    const selfConsignmentPrice = (0,es/* useRecoilValue */.sJ)((0,consignment_info_selector/* consignmentPriceInfoState */.k)({
        name: "selfConsignmentPrice"
    }));
    // 탁송료
    const consignmentPrice = !!(selfConsignmentPrice === null || selfConsignmentPrice === void 0 ? void 0 : selfConsignmentPrice.active) ? selfConsignmentPrice.number : (factory === null || factory === void 0 ? void 0 : factory.price) || 0;
    // 합계(탁송료 포함)
    const totalPriceWithConsignmentPrice = (0,es/* useRecoilValue */.sJ)((0,consignment_info_selector/* consignmentPriceInfoState */.k)({
        name: "totalPriceWithConsignmentPrice"
    }));
    // 세금계산서(인도금대납 반영전)
    const taxInvoice = (0,es/* useRecoilValue */.sJ)((0,consignment_info_selector/* consignmentPriceInfoState */.k)({
        name: "taxInvoice"
    }));
    // 계약금
    const depositInfo = (0,es/* useRecoilValue */.sJ)((0,paymentCharge_info_selector/* paymentChargeInfoState */.x)({
        name: "deposit"
    }));
    const selfDepositInfo = (0,es/* useRecoilValue */.sJ)((0,paymentCharge_info_selector/* paymentChargeInfoState */.x)({
        name: "selfDeposit"
    }));
    const deposit = (selfDepositInfo === null || selfDepositInfo === void 0 ? void 0 : selfDepositInfo.active) ? selfDepositInfo.number : depositInfo;
    // 의무보험료
    const insuarancePremiumInfo = (0,es/* useRecoilValue */.sJ)((0,paymentCharge_info_selector/* paymentChargeInfoState */.x)({
        name: "insuarancePremium"
    }));
    const selfInsuarancePremiumInfo = (0,es/* useRecoilValue */.sJ)((0,paymentCharge_info_selector/* paymentChargeInfoState */.x)({
        name: "selfInsuarancePremium"
    }));
    const insuarancePremium = (selfInsuarancePremiumInfo === null || selfInsuarancePremiumInfo === void 0 ? void 0 : selfInsuarancePremiumInfo.active) ? selfInsuarancePremiumInfo.number : insuarancePremiumInfo;
    // 구분
    const type = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankType"
    }));
    // 기간
    const period = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankPeriod"
    }));
    // 기간 직접입력
    const selfPeriod = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankSelfPeriod"
    }));
    // 선수율
    const advanceReceivedRate = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankAdvanceReceivedRate"
    }));
    /**
   *  타금융사 할부비교 테이블에서 구분, 기간, 선수율이 변동될 때, 타금융사 할부 목록 요청을 하는 함수
   * @param {inputData} inputData 업데이트명(type or period or advanceReceivedRate), 업데이트값
   *  */ const updateOtherBankList = (0,react.useCallback)((param)=>{
        let { inputName , inputValue  } = param;
        // 적용될 구분 타입
        const applyType = inputName === "type" ? inputValue : type;
        // 적용될 기간
        const applyPeriod = inputName === "period" ? inputValue : !!selfPeriod.active ? selfPeriod.number : period;
        // 적용될 선수욜
        const applyAdvanceReceivedRate = inputName === "advanceReceivedRate" ? inputValue : advanceReceivedRate;
        (async ()=>{
            // 타금융사 할부 메이커금융 상품 목록 요청
            const compareOtherBankList = await (0,paymentWay/* getCompareOtherBankList */.W)(brandNo, applyAdvanceReceivedRate, applyPeriod, applyType, isHybrid, fuelType);
            const productList = compareOtherBankList;
            // 타금융할부 목록
            const oherBankList = trim ? refineOtherBankList({
                trim,
                registrationTotalPrice,
                totalPriceWithoutConsignmentPrice,
                consignmentPrice,
                totalPriceWithConsignmentPrice,
                taxInvoice,
                deposit,
                insuarancePremium,
                productList,
                period: applyPeriod,
                advanceReceivedRate: applyAdvanceReceivedRate
            }).sort((a, b)=>{
                // 월납입금 오름차순
                // return a.monthlyPayment - b.monthlyPayment;
                // 금리 오름차순
                return a.interestRate - b.interestRate;
            }) : [];
            setOtherBankMakerFinanceList((prev)=>prev.map((state)=>state.id === id ? {
                        ...state,
                        list: oherBankList
                    } : state));
        })();
    }, [
        id,
        brandNo,
        type,
        period,
        selfPeriod,
        advanceReceivedRate
    ]);
    return {
        updateOtherBankList
    };
}
/* harmony default export */ var fetch_useFetchOtherBank = (useFetchOtherBank);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/radio/OtherBankTypeRadio.tsx








/**
 *  타금융사 할부 조건 구분 라디오 컴포넌트
 * @param {number} type 개인(1) or 법인(2)
 *  */ function OtherBankTypeRadio(param) {
    let { type  } = param;
    // select
    const checked = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankType"
    }));
    // function
    const { updateOtherBankList  } = fetch_useFetchOtherBank();
    const update = (0,useUpdateInfo/* default */.Z)(atom/* otherBankTypeInfoState */.G9);
    const onChange = (e)=>{
        if (e.target.checked) {
            update(type);
            updateOtherBankList({
                inputName: "type",
                inputValue: type
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioLabel/* default */.Z, {
        name: "condition-type",
        checked: checked === type,
        onChange: onChange,
        text: type === 1 ? "개인" : "법인"
    });
}
/* harmony default export */ var radio_OtherBankTypeRadio = (OtherBankTypeRadio);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/contents/OtherBankTypeContents.tsx

function OtherBankTypeContents_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  gap: 8px;\n"
    ]);
    OtherBankTypeContents_templateObject = function() {
        return data;
    };
    return data;
}




const OtherBankTypeContents_Base = emotion_styled_browser_esm/* default.div */.Z.div(OtherBankTypeContents_templateObject());
/**
 *  타금융사 할부조건 구분 contents 컴포넌트
 *  */ function OtherBankTypeContents() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OtherBankTypeContents_Base, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_OtherBankTypeRadio, {
                type: 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_OtherBankTypeRadio, {
                type: 2
            })
        ]
    });
}
/* harmony default export */ var contents_OtherBankTypeContents = (OtherBankTypeContents);

// EXTERNAL MODULE: ./src/components/common/checkbox/CheckSelfForNumberWithSelect.tsx
var CheckSelfForNumberWithSelect = __webpack_require__(3784);
;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/select/OtherBankPeriod.tsx

function OtherBankPeriod_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n"
    ]);
    OtherBankPeriod_templateObject = function() {
        return data;
    };
    return data;
}










const OtherBankPeriod_Base = emotion_styled_browser_esm/* default.div */.Z.div(OtherBankPeriod_templateObject());
// 고정 기간값
const MONTH_LIST = [
    12,
    24,
    36,
    48,
    60,
    72,
    84,
    96,
    108,
    120
];
/**
 *  타금융사 할부조건 기간 select 컴포넌트
 *  */ function OtherBankPeriod() {
    // selected
    const originValue = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankPeriod"
    }));
    const selfPeriod = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankSelfPeriod"
    }));
    const { active , number  } = selfPeriod;
    // function
    const { updateOtherBankList  } = fetch_useFetchOtherBank();
    const update = (0,useUpdateInfo/* default */.Z)(atom/* otherBankPeriodInfoState */.$D);
    const selfUpdate = (0,useUpdateInfo/* default */.Z)(atom/* otherBankSelfPeriodInfoState */.$O);
    const onBlur = (param)=>{
        if (param !== originValue) {
            update(param);
            updateOtherBankList({
                inputName: "period",
                inputValue: param
            });
        }
    };
    const onBlurSelf = (param)=>{
        const applyActive = param.active;
        const applyParam = param.number > 120 ? 120 : param.number < 0 ? 1 : param.number;
        if (applyActive !== active || applyParam !== number) {
            selfUpdate({
                active: applyActive,
                number: applyParam
            });
            updateOtherBankList({
                inputName: "period",
                inputValue: applyActive ? applyParam : originValue
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OtherBankPeriod_Base, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckSelfForNumberWithSelect/* default */.Z, {
                list: MONTH_LIST,
                originValue: originValue,
                selfValue: number,
                unit: "회",
                checked: active,
                update: onBlur,
                updateSelf: onBlurSelf,
                inputWidth: "40px",
                notComma: true,
                boxSize: "13px",
                selfValuePriority: true
            }),
            active && /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                children: "회"
            })
        ]
    });
}
/* harmony default export */ var select_OtherBankPeriod = (OtherBankPeriod);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/contents/OtherBankPeriodContents.tsx

function OtherBankPeriodContents_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    OtherBankPeriodContents_templateObject = function() {
        return data;
    };
    return data;
}




const OtherBankPeriodContents_Base = emotion_styled_browser_esm/* default.div */.Z.div(OtherBankPeriodContents_templateObject());
/**
 *  타금융사 할부조건 기간 컨텐츠 컴포넌트
 *  */ function OtherBankPeriodContents() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherBankPeriodContents_Base, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_OtherBankPeriod, {})
    });
}
/* harmony default export */ var contents_OtherBankPeriodContents = (OtherBankPeriodContents);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/radio/OtherBankInstallmentRadio.tsx







/**
 *  타금융사 할부조건 선수율/할부원금 라디오 로직 컴포넌트
 * @param {string} text 할부원금 or 선수율
 * @param {string} type advanceReceivedRate or installmentPrincipal
 *  */ function OtherBankInstallmentRadio(param) {
    let { text , type  } = param;
    // selected
    const principalType = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankPrincipalType"
    }));
    // function
    const update = (0,useUpdateInfo/* default */.Z)(atom/* otherBankPrincipalTypeInfoState */.ip);
    const onChange = (e)=>{
        const checked = e.target.checked;
        checked && update(type);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioLabel/* default */.Z, {
        text: text,
        name: "otherBank-principalType",
        checked: principalType === type,
        onChange: onChange,
        RadioSize: "10px",
        fontSize: "11px"
    });
}
/* harmony default export */ var radio_OtherBankInstallmentRadio = (OtherBankInstallmentRadio);

// EXTERNAL MODULE: ./src/lib/estimate/common/paymentWay/calculator/installment.ts
var installment = __webpack_require__(7376);
// EXTERNAL MODULE: ./src/data/estimate/common/paymentWay/list/selector.ts
var list_selector = __webpack_require__(8458);
;// CONCATENATED MODULE: ./src/hooks/estimate/common/otherBank/useCalculatorForOtherBankCondition.ts













/**
 *  메이커금융 선택시 기본값 세팅 함수를 리턴하는 hook
 *  */ function useCalculatorForOtherBankCondition() {
    // selected
    // 트림
    const trim = (0,es/* useRecoilValue */.sJ)((0,info_selector/* selectCarInfoState */.s)({
        name: "trim"
    }));
    // 등록합계
    const registrationTotalPrice = (0,es/* useRecoilValue */.sJ)((0,incidentalExpense_info_selector/* incidentalExpenseInfoState */.w)({
        name: "registrationTotalPrice"
    }));
    // 합계(탁송료 제외)
    const totalPriceWithoutConsignmentPrice = (0,es/* useRecoilValue */.sJ)((0,tax_info_selector/* exemptionOrTaxationInfoState */.x)({
        name: "totalPriceWithoutConsignmentPrice"
    }));
    // 출고장
    const factory = (0,es/* useRecoilValue */.sJ)((0,consignment_info_selector/* consignmentPriceInfoState */.k)({
        name: "factory"
    }));
    // 탁송료 직접 입력
    const selfConsignmentPrice = (0,es/* useRecoilValue */.sJ)((0,consignment_info_selector/* consignmentPriceInfoState */.k)({
        name: "selfConsignmentPrice"
    }));
    // 합계(탁송료 포함)
    const totalPriceWithConsignmentPrice = (0,es/* useRecoilValue */.sJ)((0,consignment_info_selector/* consignmentPriceInfoState */.k)({
        name: "totalPriceWithConsignmentPrice"
    }));
    // 세금계산서(인도금대납 반영전)
    const taxInvoice = (0,es/* useRecoilValue */.sJ)((0,consignment_info_selector/* consignmentPriceInfoState */.k)({
        name: "taxInvoice"
    }));
    // 메이커금융 상품 목록
    const productList = (0,es/* useRecoilValue */.sJ)((0,list_selector/* paymentWayListState */.T)({
        name: "otherBankMakerFinance"
    }));
    // 메이커금융 상품
    const product = (0,es/* useRecoilValue */.sJ)(atom/* otherBankConditionInfoState */.he);
    // 기간 직접입력
    const selfPeriodInfo = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankSelfPeriod"
    }));
    // 기간
    const periodInfo = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankPeriod"
    }));
    // 선수율
    const advanceReceivedRateInfo = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankAdvanceReceivedRate"
    }));
    // 선수율(소수점)
    const advanceReceivedFullRateInfo = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankAdvanceReceivedFullRate"
    }));
    // 할부원금
    const installmentPrincipalInfo = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankInstallmentPrincipal"
    }));
    // 등록까지
    const untilRegistrationInfo = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankUntilRegistration"
    }));
    // 출고까지
    const untilReleaseInfo = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankUntilRelease"
    }));
    // 인도+탁송
    const deliveryMoneyWithConsignmentPriceInfo = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankDeliveryMoneyWithConsignmentPrice"
    }));
    // 인도-탁송
    const deliveryMoneyWithoutConsignmentPriceInfo = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankDeliveryMoneyWithoutConsignmentPrice"
    }));
    // 계약금
    const depositInfo = (0,es/* useRecoilValue */.sJ)((0,paymentCharge_info_selector/* paymentChargeInfoState */.x)({
        name: "deposit"
    }));
    const selfDepositInfo = (0,es/* useRecoilValue */.sJ)((0,paymentCharge_info_selector/* paymentChargeInfoState */.x)({
        name: "selfDeposit"
    }));
    const deposit = (selfDepositInfo === null || selfDepositInfo === void 0 ? void 0 : selfDepositInfo.active) ? selfDepositInfo.number : depositInfo;
    // 의무보험료
    const insuarancePremiumInfo = (0,es/* useRecoilValue */.sJ)((0,paymentCharge_info_selector/* paymentChargeInfoState */.x)({
        name: "insuarancePremium"
    }));
    const selfInsuarancePremiumInfo = (0,es/* useRecoilValue */.sJ)((0,paymentCharge_info_selector/* paymentChargeInfoState */.x)({
        name: "selfInsuarancePremium"
    }));
    const insuarancePremium = (selfInsuarancePremiumInfo === null || selfInsuarancePremiumInfo === void 0 ? void 0 : selfInsuarancePremiumInfo.active) ? selfInsuarancePremiumInfo.number : insuarancePremiumInfo;
    // update
    const updateAdvanceReceivedRate = (0,useUpdateInfo/* default */.Z)(atom/* otherBankAdvanceReceivedRateInfoState */.lE); // 선수율
    const updateAdvanceReceivedFullRate = (0,useUpdateInfo/* default */.Z)(atom/* otherBankAdvanceReceivedFullRateInfoState */.LQ); // 선수율(소수점)
    const updateInstallmentPrincipal = (0,useUpdateInfo/* default */.Z)(atom/* otherBankInstallmentPrincipalInfoState */.b_); // 할부원금
    const updateUntilRegistration = (0,useUpdateInfo/* default */.Z)(atom/* otherBankUntilRegistrationInfoState */.Wc); // 등록까지
    const updateuntilRelease = (0,useUpdateInfo/* default */.Z)(atom/* otherBankUntilReleaseInfoState */.ES); // 출고까지
    const updatedeliveryPriceWithConsignmentPrice = (0,useUpdateInfo/* default */.Z)(atom/* otherBankDeliveryMoneyWithConsignmentPriceInfoState */.a7); // 인도+탁송
    const updatedeliveryPriceWithoutConsignmentPrice = (0,useUpdateInfo/* default */.Z)(atom/* otherBankDeliveryMoneyWithoutConsignmentPriceInfoState */.je); // 인도-탁송
    // function
    const { updateOtherBankList  } = fetch_useFetchOtherBank();
    /**
   *  원금 로우에서 값은 변경할 때 계산되는 함수
   * @param {InputData} inputData 변경된 값
   * 선수율(advanceReceivedRate), 할부원금(installmentPrincipal), 가용금액(availableAmount), 등록까지(untilRegistration), 출고까지(untilRelease), 인도+탁송(deliveryMoneyWithConsignmentPrice), 인도-탁송(deliveryMoneyWithoutConsignmentPrice)
   *  */ const updateInstallment = (0,react.useCallback)((param)=>{
        let { inputName , inputValue  } = param;
        // 적용될 기간
        const period = !!(selfPeriodInfo === null || selfPeriodInfo === void 0 ? void 0 : selfPeriodInfo.active) ? selfPeriodInfo.number : periodInfo;
        // 적용될 탁송료
        const consignmentPrice = !!(selfConsignmentPrice === null || selfConsignmentPrice === void 0 ? void 0 : selfConsignmentPrice.active) ? selfConsignmentPrice.number : (factory === null || factory === void 0 ? void 0 : factory.price) || 0;
        // 적용될 선수율
        const applyAdvanceReceivedRate = inputName === "advanceReceivedRate" ? inputValue : advanceReceivedRateInfo; // 선수율
        const { installmentPrincipal , advanceReceivedRate , advanceReceivedFullRate , deliveryMoneyWithConsignmentPrice , deliveryMoneyWithoutConsignmentPrice , untilRelease , untilRegistration  } = (0,installment/* installmentProcess */.s)({
            taxInvoice,
            totalPriceWithoutConsignmentPrice,
            totalPriceWithConsignmentPrice,
            consignmentPrice,
            registrationTotalPrice,
            period,
            advanceReceivedRate: applyAdvanceReceivedRate,
            deposit,
            insuarancePremium,
            trim,
            product,
            productList,
            inputData: {
                name: inputName,
                value: inputValue
            }
        });
        const correctAdvanceReceivedRate = advanceReceivedRate > 120 ? 120 : advanceReceivedRate < 0 ? 0 : advanceReceivedRate;
        updateOtherBankList({
            inputName: "advanceReceivedRate",
            inputValue: correctAdvanceReceivedRate
        });
        updateAdvanceReceivedRate(correctAdvanceReceivedRate); // 선수율
        updateAdvanceReceivedFullRate(advanceReceivedFullRate); // 선수율 소수점
        updateInstallmentPrincipal(installmentPrincipal); // 할부원금
        updateUntilRegistration(untilRegistration); // 등록까지
        updateuntilRelease(untilRelease); // 출고까지
        updatedeliveryPriceWithConsignmentPrice(deliveryMoneyWithConsignmentPrice); // 인도+탁송
        updatedeliveryPriceWithoutConsignmentPrice(deliveryMoneyWithoutConsignmentPrice); // 인도-탁송
    }, [
        taxInvoice,
        totalPriceWithoutConsignmentPrice,
        totalPriceWithConsignmentPrice,
        selfConsignmentPrice,
        factory,
        registrationTotalPrice,
        selfPeriodInfo,
        periodInfo,
        advanceReceivedRateInfo,
        advanceReceivedFullRateInfo,
        installmentPrincipalInfo,
        untilRegistrationInfo,
        untilReleaseInfo,
        deliveryMoneyWithConsignmentPriceInfo,
        deliveryMoneyWithoutConsignmentPriceInfo,
        deposit,
        insuarancePremium
    ]);
    return {
        updateInstallment
    };
}
/* harmony default export */ var otherBank_useCalculatorForOtherBankCondition = (useCalculatorForOtherBankCondition);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/select/OtherBankAdvanceReceivedRate.tsx

function OtherBankAdvanceReceivedRate_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 53px;\n  height: 25px;\n  border: 1px solid ",
        ";\n  ",
        ";\n"
    ]);
    OtherBankAdvanceReceivedRate_templateObject = function() {
        return data;
    };
    return data;
}








const Select = emotion_styled_browser_esm/* default.select */.Z.select(OtherBankAdvanceReceivedRate_templateObject(), color/* GRAY */.pF, (0,font/* fontFrame */.C)("400", "11px", "1", color/* BLACK */.E5));
// 고정된 선수율 목록
const ADVANCE_RECEIVED_RATE_LIST = Array.from({
    length: 100
}, (v, i)=>i).map((num)=>num === 0 ? "전액" : num); // [0, ..... 99];
/**
 *  타금융사 할부조건 선수율 select 로직
 */ function OtherBankAdvanceReceivedRate() {
    // selected
    const value = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankAdvanceReceivedRate"
    })); // 선수율
    const principalType = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankPrincipalType"
    })); // 원금 타입
    // function
    const { updateInstallment  } = otherBank_useCalculatorForOtherBankCondition();
    const onChange = (e)=>{
        const advanceReceivedRate = Number(e.target.value);
        updateInstallment({
            inputName: "advanceReceivedRate",
            inputValue: advanceReceivedRate
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, {
        value: value,
        onChange: onChange,
        disabled: principalType !== "advanceReceivedRate",
        children: !!(ADVANCE_RECEIVED_RATE_LIST === null || ADVANCE_RECEIVED_RATE_LIST === void 0 ? void 0 : ADVANCE_RECEIVED_RATE_LIST.length) && ADVANCE_RECEIVED_RATE_LIST.map((rate)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: rate === "전액" ? 0 : rate,
                children: rate === "전액" ? "전액" : "".concat(rate, "%")
            }, rate))
    });
}
/* harmony default export */ var select_OtherBankAdvanceReceivedRate = (OtherBankAdvanceReceivedRate);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/contents/OtherBankAdvanceReceivedFullRate.tsx






/**
 *  타금융사 할부조건 선수율(소수점) 로직 컴포넌트
 */ function OtherBankAdvanceReceivedFullRate() {
    // selected
    const value = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankAdvanceReceivedFullRate"
    })); // 선수율(소수점)
    const principalType = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankPrincipalType"
    })); // 원금 타입
    const text = "(".concat(Math.floor(value * 100) / 100, "%)");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
        fontSize: "10px",
        color: principalType === "advanceReceivedRate" ? color/* BLACK */.E5 : color/* GRAY */.pF,
        children: text
    });
}
/* harmony default export */ var contents_OtherBankAdvanceReceivedFullRate = (OtherBankAdvanceReceivedFullRate);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/contents/OtherBankAdvanceReceivedRateContents.tsx

function OtherBankAdvanceReceivedRateContents_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 4px;\n  align-items: center;\n\n  @media (max-width: 768px) {\n    display: grid;\n    grid-template-columns: auto auto 1fr;\n\n    span:last-of-type {\n      justify-self: end;\n    }\n  }\n"
    ]);
    OtherBankAdvanceReceivedRateContents_templateObject = function() {
        return data;
    };
    return data;
}






const OtherBankAdvanceReceivedRateContents_Base = emotion_styled_browser_esm/* default.div */.Z.div(OtherBankAdvanceReceivedRateContents_templateObject());
/**
 *  타금융사 할부조건 선수율 컨텐츠 컴포넌트
 *  */ function OtherBankAdvanceReceivedRateContents() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OtherBankAdvanceReceivedRateContents_Base, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_OtherBankInstallmentRadio, {
                type: "advanceReceivedRate",
                text: "선수율"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_OtherBankAdvanceReceivedRate, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_OtherBankAdvanceReceivedFullRate, {})
        ]
    });
}
/* harmony default export */ var contents_OtherBankAdvanceReceivedRateContents = (OtherBankAdvanceReceivedRateContents);

// EXTERNAL MODULE: ./src/components/common/input/NumberInput.tsx
var NumberInput = __webpack_require__(982);
;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/input/OtherBankInstallmentPrincipal.tsx






/**
 *  타금융사 할부조건 할부원금 input 로직 컴포넌트
 *  */ function OtherBankInstallmentPrincipal() {
    // selected
    // 할부원금
    const value = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankInstallmentPrincipal"
    }));
    // 원금 종류
    const type = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankPrincipalType"
    }));
    // function
    const { updateInstallment  } = otherBank_useCalculatorForOtherBankCondition();
    const onBlur = (e)=>{
        const installmentPrincipal = Number(e.target.value);
        updateInstallment({
            inputName: "installmentPrincipal",
            inputValue: installmentPrincipal
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* default */.Z, {
        width: "80px",
        fontSize: "10px",
        name: "installmentPrincipal",
        disabled: type !== "installmentPrincipal",
        onBlur: onBlur,
        value: value
    });
}
/* harmony default export */ var input_OtherBankInstallmentPrincipal = (OtherBankInstallmentPrincipal);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/contents/OtherBankInstallmentPrincipalContents.tsx

function OtherBankInstallmentPrincipalContents_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    OtherBankInstallmentPrincipalContents_templateObject = function() {
        return data;
    };
    return data;
}





const OtherBankInstallmentPrincipalContents_Base = emotion_styled_browser_esm/* default.div */.Z.div(OtherBankInstallmentPrincipalContents_templateObject());
/**
 *  타금융사 할부조건 할부원금 컨텐츠 컴포넌트
 *  */ function OtherBankInstallmentPrincipalContents() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OtherBankInstallmentPrincipalContents_Base, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_OtherBankInstallmentRadio, {
                type: "installmentPrincipal",
                text: "할부원금"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_OtherBankInstallmentPrincipal, {})
        ]
    });
}
/* harmony default export */ var contents_OtherBankInstallmentPrincipalContents = (OtherBankInstallmentPrincipalContents);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/radio/OtherBankPaymentTypeRadio.tsx

function OtherBankPaymentTypeRadio_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 10px;\n  height: 10px;\n"
    ]);
    OtherBankPaymentTypeRadio_templateObject = function() {
        return data;
    };
    return data;
}







const Radio = emotion_styled_browser_esm/* default.input */.Z.input(OtherBankPaymentTypeRadio_templateObject());
/**
 *  타금융사 할부조건 가용금액 라디오 컴포넌트
 *  */ function OtherBankPaymentTypeRadio() {
    // selected
    const principalType = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankPrincipalType"
    }));
    // function
    const update = (0,useUpdateInfo/* default */.Z)(atom/* otherBankPrincipalTypeInfoState */.ip);
    const onChange = (e)=>{
        const checked = e.target.checked;
        checked && update("paymentType");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, {
        type: "radio",
        name: "otherBank-principalType",
        onChange: onChange,
        checked: principalType === "paymentType"
    });
}
/* harmony default export */ var radio_OtherBankPaymentTypeRadio = (OtherBankPaymentTypeRadio);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/select/OtherBankPaymentType.tsx

function OtherBankPaymentType_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 60px;\n  height: 25px;\n  border: 1px solid ",
        ";\n  ",
        ";\n  -webkit-appearance: none;\n"
    ]);
    OtherBankPaymentType_templateObject = function() {
        return data;
    };
    return data;
}









const OtherBankPaymentType_Select = emotion_styled_browser_esm/* default.select */.Z.select(OtherBankPaymentType_templateObject(), color/* GRAY */.pF, (0,font/* fontFrame */.C)("400", "11px", "1", color/* BLACK */.E5));
/**
 *  타금융사 할부조건 가용금액 셀렉트 로직 컴포넌트
 *  */ function OtherBankPaymentType() {
    // selected
    const paymentType = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankPaymentType"
    }));
    // function
    const update = (0,useUpdateInfo/* default */.Z)(atom/* otherBankPaymentTypeInfoState */.Ko);
    const onChange = (e)=>update(e.target.value);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OtherBankPaymentType_Select, {
        value: paymentType,
        onChange: onChange,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: "availableAmount",
                children: "가용금액"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: "untilRegistration",
                children: "등록까지"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: "untilRelease",
                children: "출고까지"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: "deliveryMoneyWithConsignmentPrice",
                children: "인도(+탁송)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: "deliveryMoneyWithoutConsignmentPrice",
                children: "인도(-탁송)"
            })
        ]
    });
}
/* harmony default export */ var select_OtherBankPaymentType = (OtherBankPaymentType);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/payment/OtherBankUntilRegistration.tsx






/**
 *  타금융사 할부조건 등록까지 직접입력 로직 컴포넌트
 * @param {boolean} isDisabled 비활성화 여부
 *  */ function OtherBankUntilRegistration(param) {
    let { isDisabled  } = param;
    // state 추가한 이유는 산출후에 가격이 계속 같지만 input의 state는 계속 변동되기 때문에 실제 value와 input의 state의 sync가 안맞아 sync를 맞추기 위한 리렌더링 발생을 위해 추가함
    const [input, setInput] = (0,react.useState)(0);
    // selected
    const value = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankUntilRegistration"
    }));
    // function
    const { updateInstallment  } = otherBank_useCalculatorForOtherBankCondition();
    const onBlur = (e)=>{
        const untilRegistration = Number(e.target.value);
        updateInstallment({
            inputName: "untilRegistration",
            inputValue: untilRegistration
        });
        setInput(untilRegistration);
    };
    (0,react.useEffect)(()=>{
        // state 추가한 이유는 산출후에 가격이 계속 같지만 input의 state는 계속 변동되기 때문에 실제 value와 input의 state의 sync가 안맞아 sync를 맞추기 위한 리렌더링 발생을 위해 추가함
        input !== value && setInput(value);
    }, [
        input,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* default */.Z, {
        width: "70px",
        fontSize: "10px",
        name: "untilResitration",
        onBlur: onBlur,
        value: Math.round(input),
        disabled: isDisabled
    });
}
/* harmony default export */ var payment_OtherBankUntilRegistration = (OtherBankUntilRegistration);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/payment/OtherBankUntilRelease.tsx






/**
 *  타금융사 할부조건 출고까지 직접입력 로직 컴포넌트
 * @param {boolean} isDisabled 비활성화 여부
 *  */ function OtherBankUntilRelease(param) {
    let { isDisabled  } = param;
    // state 추가한 이유는 산출후에 가격이 계속 같지만 input의 state는 계속 변동되기 때문에 실제 value와 input의 state의 sync가 안맞아 sync를 맞추기 위한 리렌더링 발생을 위해 추가함
    const [input, setInput] = (0,react.useState)(0);
    // selected
    const value = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankUntilRelease"
    }));
    // function
    const { updateInstallment  } = otherBank_useCalculatorForOtherBankCondition();
    const onBlur = (e)=>{
        const untilRelease = Number(e.target.value);
        updateInstallment({
            inputName: "untilRelease",
            inputValue: untilRelease
        });
        setInput(untilRelease);
    };
    (0,react.useEffect)(()=>{
        // state 추가한 이유는 산출후에 가격이 계속 같지만 input의 state는 계속 변동되기 때문에 실제 value와 input의 state의 sync가 안맞아 sync를 맞추기 위한 리렌더링 발생을 위해 추가함
        input !== value && setInput(value);
    }, [
        input,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* default */.Z, {
        width: "70px",
        fontSize: "10px",
        name: "untilRelease",
        value: Math.round(input),
        onBlur: onBlur,
        disabled: isDisabled
    });
}
/* harmony default export */ var payment_OtherBankUntilRelease = (OtherBankUntilRelease);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/payment/OtherBankDeliveryMoneyWithConsignmentPrice.tsx






/**
 *  타금융사 할부조건 인도+탁송 직접입력 로직 컴포넌트
 * @param {boolean} isDisabled 비활성화 여부
 *  */ function OtherBankDeliveryMoneyWithConsignmentPrice(param) {
    let { isDisabled  } = param;
    // state 추가한 이유는 산출후에 가격이 계속 같지만 input의 state는 계속 변동되기 때문에 실제 value와 input의 state의 sync가 안맞아 sync를 맞추기 위한 리렌더링 발생을 위해 추가함
    const [input, setInput] = (0,react.useState)(0);
    // selected
    const value = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankDeliveryMoneyWithConsignmentPrice"
    }));
    // function
    const { updateInstallment  } = otherBank_useCalculatorForOtherBankCondition();
    const onBlur = (e)=>{
        const deliveryMoneyWithConsignmentPrice = Number(e.target.value);
        updateInstallment({
            inputName: "deliveryMoneyWithConsignmentPrice",
            inputValue: deliveryMoneyWithConsignmentPrice
        });
        setInput(deliveryMoneyWithConsignmentPrice);
    };
    (0,react.useEffect)(()=>{
        // state 추가한 이유는 산출후에 가격이 계속 같지만 input의 state는 계속 변동되기 때문에 실제 value와 input의 state의 sync가 안맞아 sync를 맞추기 위한 리렌더링 발생을 위해 추가함
        input !== value && setInput(value);
    }, [
        input,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* default */.Z, {
        width: "70px",
        fontSize: "10px",
        name: "deliveryMoneyWithConsignmentPrice",
        value: Math.round(input),
        onBlur: onBlur,
        disabled: isDisabled
    });
}
/* harmony default export */ var payment_OtherBankDeliveryMoneyWithConsignmentPrice = (OtherBankDeliveryMoneyWithConsignmentPrice);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/payment/OtherBankDeliveryMoneyWithoutConsignmentPrice.tsx






/**
 *  타금융사 할부조건 인도-탁송 직접입력 로직 컴포넌트
 * @param {boolean} isDisabled 비활성화 여부
 *  */ function OtherBankDeliveryMoneyWithoutConsignmentPrice(param) {
    let { isDisabled  } = param;
    // state 추가한 이유는 산출후에 가격이 계속 같지만 input의 state는 계속 변동되기 때문에 실제 value와 input의 state의 sync가 안맞아 sync를 맞추기 위한 리렌더링 발생을 위해 추가함
    const [input, setInput] = (0,react.useState)(0);
    // selected
    const value = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankDeliveryMoneyWithoutConsignmentPrice"
    }));
    // function
    const { updateInstallment  } = otherBank_useCalculatorForOtherBankCondition();
    const onBlur = (e)=>{
        const deliveryMoneyWithoutConsignmentPrice = Number(e.target.value);
        updateInstallment({
            inputName: "deliveryMoneyWithoutConsignmentPrice",
            inputValue: deliveryMoneyWithoutConsignmentPrice
        });
        setInput(deliveryMoneyWithoutConsignmentPrice);
    };
    (0,react.useEffect)(()=>{
        // state 추가한 이유는 산출후에 가격이 계속 같지만 input의 state는 계속 변동되기 때문에 실제 value와 input의 state의 sync가 안맞아 sync를 맞추기 위한 리렌더링 발생을 위해 추가함
        input !== value && setInput(value);
    }, [
        input,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* default */.Z, {
        width: "70px",
        fontSize: "10px",
        name: "deliveryMoneyWithoutConsignmentPrice",
        value: Math.round(input),
        onBlur: onBlur,
        disabled: isDisabled
    });
}
/* harmony default export */ var payment_OtherBankDeliveryMoneyWithoutConsignmentPrice = (OtherBankDeliveryMoneyWithoutConsignmentPrice);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/payment/OtherBankPaymentContents.tsx








/**
 *  타금융사 할부조건 payment 타입별 묶음 contents
 *  */ function OtherBankPaymentContents() {
    // selected
    const principalType = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankPrincipalType"
    }));
    const isDisabled = principalType !== "paymentType";
    const paymentType = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankPaymentType"
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (paymentType === "availableAmount" || paymentType === "untilRegistration") && /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_OtherBankUntilRegistration, {
                isDisabled: isDisabled
            }),
            paymentType === "untilRelease" && /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_OtherBankUntilRelease, {
                isDisabled: isDisabled
            }),
            paymentType === "deliveryMoneyWithConsignmentPrice" && /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_OtherBankDeliveryMoneyWithConsignmentPrice, {
                isDisabled: isDisabled
            }),
            paymentType === "deliveryMoneyWithoutConsignmentPrice" && /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_OtherBankDeliveryMoneyWithoutConsignmentPrice, {
                isDisabled: isDisabled
            })
        ]
    });
}
/* harmony default export */ var payment_OtherBankPaymentContents = (OtherBankPaymentContents);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/contents/OtherBankPaymentTypeContents.tsx

function OtherBankPaymentTypeContents_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  @media (max-width: 768px) {\n    display: grid;\n    grid-template-columns: auto auto 1fr;\n\n    input:last-of-type {\n      justify-self: end;\n    }\n  }\n"
    ]);
    OtherBankPaymentTypeContents_templateObject = function() {
        return data;
    };
    return data;
}






const OtherBankPaymentTypeContents_Base = emotion_styled_browser_esm/* default.div */.Z.div(OtherBankPaymentTypeContents_templateObject());
/**
 *  타금융사 할부조건 가용금액 컨텐츠 컴포넌트
 *  */ function OtherBankPaymentTypeContents() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OtherBankPaymentTypeContents_Base, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_OtherBankPaymentTypeRadio, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_OtherBankPaymentType, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_OtherBankPaymentContents, {})
        ]
    });
}
/* harmony default export */ var contents_OtherBankPaymentTypeContents = (OtherBankPaymentTypeContents);

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/table/OtherBankConditionTable.tsx

function OtherBankConditionTable_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 228px;\n  height: 551px;\n  border: 1px solid ",
        ";\n\n  & tbody th {\n    border-right: 1px solid ",
        ";\n    border-bottom: 1px solid ",
        ";\n  }\n\n  & tbody td {\n    height: 40px;\n    padding: 0 8px;\n  }\n\n  & tbody td:not(.not-border-bottom) {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  & > tbody > tr:last-of-type td {\n    background-color: #f2f3f5;\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n  }\n"
    ]);
    OtherBankConditionTable_templateObject = function() {
        return data;
    };
    return data;
}
function OtherBankConditionTable_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  background-color: ",
        ";\n  height: 50px;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    OtherBankConditionTable_templateObject1 = function() {
        return data;
    };
    return data;
}
function OtherBankConditionTable_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 66px;\n  background-color: #eaf5ff;\n"
    ]);
    OtherBankConditionTable_templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  row-gap: 4px;\n  list-style-type: decimal;\n  padding: 0 15px;\n\n  & > li {\n    ",
        ";\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 8px 0;\n  row-gap: 8px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n  font-weight: bold;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}















const OtherBankConditionTable_Table = emotion_styled_browser_esm/* default.table */.Z.table(OtherBankConditionTable_templateObject(), color/* GRAY */.pF, color/* GRAY */.pF, color/* GRAY */.pF, color/* GRAY */.pF);
const Header = emotion_styled_browser_esm/* default.th */.Z.th(OtherBankConditionTable_templateObject1(), color/* BLACK */.E5, color/* LIGHT_GRAY */.ob, color/* GRAY */.pF);
const Th = emotion_styled_browser_esm/* default.th */.Z.th(OtherBankConditionTable_templateObject2());
const Ol = emotion_styled_browser_esm/* default.ol */.Z.ol(_templateObject3(), (0,font/* fontFrame */.C)("400", "13px", "1", color/* BLACK */.E5));
const NoticeWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4());
const OrangeStrong = emotion_styled_browser_esm/* default.strong */.Z.strong(_templateObject5(), color/* ORANGE */.ud);
const Strong = emotion_styled_browser_esm/* default.strong */.Z.strong(_templateObject6());
/**
 *  타금융사 할부비교 할부조건 테이블 컴포넌트
 *  */ function OtherBankConditionTable() {
    // device
    const device = (0,useDevice/* default */.Z)();
    // select
    const installmentPrincipal = (0,es/* useRecoilValue */.sJ)((0,selector/* otherBankInfoState */.c)({
        name: "otherBankInstallmentPrincipal"
    }));
    // function
    const { updateInstallment  } = otherBank_useCalculatorForOtherBankCondition();
    (0,react.useEffect)(()=>{
        installmentPrincipal === 0 && updateInstallment({
            inputName: "",
            inputValue: 0
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OtherBankConditionTable_Table, {
        summary: "할부조건 테이블",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                        colSpan: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                            fontSize: "18px",
                            fontWeight: "500",
                            children: "할부비교"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                    children: "구분"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_OtherBankTypeContents, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                    children: "기간"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_OtherBankPeriodContents, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                                rowSpan: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                    children: "원금"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                className: "not-border-bottom",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_OtherBankAdvanceReceivedRateContents, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            className: "not-border-bottom",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_OtherBankPaymentTypeContents, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_OtherBankInstallmentPrincipalContents, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            colSpan: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoticeWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                        children: "* 타 금융사 할부 견적 이용안내"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Ol, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                                    children: "기간 및 선수율 선택"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                                    children: "월 납입급 등 확인"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Span/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OrangeStrong, {
                                                            children: "적용"
                                                        }),
                                                        " 클릭 후 세부조건 변경"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                                    children: "견적서 하단에 있는 금융상담신청 버튼 클릭"
                                                })
                                            })
                                        ]
                                    }),
                                    device === "pc" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Span/* default */.Z, {
                                                children: "금융상담신청 버튼을 클릭하시면 담당자가 내용 확인 후 진행이 가능하도록 연락을 드리겠습니다."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Span/* default */.Z, {
                                                children: [
                                                    "문의사항은 ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                        children: "1566-1638"
                                                    }),
                                                    " 로 연락 주시면 자세하게 안내해 드리겠습니다."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var table_OtherBankConditionTable = (/*#__PURE__*/react.memo(OtherBankConditionTable));

;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/contents/OtherBankContents.tsx

function OtherBankContents_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto auto;\n  column-gap: 8px;\n  max-height: 85vh;\n  overflow-y: overlay;\n\n  & > h1 {\n    grid-column: span 2;\n  }\n\n  & > table:first-of-type {\n    align-self: end;\n  }\n\n  @media (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n    row-gap: 8px;\n    width: 90vw;\n    max-height: 75vh;\n  }\n"
    ]);
    OtherBankContents_templateObject = function() {
        return data;
    };
    return data;
}






const OtherBankContents_Base = emotion_styled_browser_esm/* default.div */.Z.div(OtherBankContents_templateObject());
/**
 *  타금융사 할부비교 컨텐츠 컴포넌트
 * @param {function} closeEvent 모달 닫기 이벤트 함수
 *  */ function OtherBankContents(param) {
    let { closeEvent  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                text: "타금융사 할부비교"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OtherBankContents_Base, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(table_OtherBankConditionTable, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_OtherBankListContents, {
                        closeEvent: closeEvent
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var contents_OtherBankContents = (/*#__PURE__*/react.memo(OtherBankContents));

// EXTERNAL MODULE: ./src/data/estimate/common/modal/atom.ts
var modal_atom = __webpack_require__(4457);
// EXTERNAL MODULE: ./src/data/estimate/common/paymentWay/info/selector.ts
var paymentWay_info_selector = __webpack_require__(2879);
;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/modal/OtherBankModal.tsx









/**
 *  타금융사 할부비교 모달 컴포넌트
 *  */ function OtherBankModal() {
    // set
    const setSelector = (0,es/* useSetRecoilState */.Zl)(modal_atom/* otherBankSelectorState */.Rl);
    // select
    const checkIndex = (0,es/* useRecoilValue */.sJ)((0,paymentWay_info_selector/* paymentWayInfoState */.i)({
        name: "selectPaymentWayTable"
    }));
    // function
    const updateTargetIndex = (0,useUpdateInfo/* default */.Z)(atom/* targetTableInfoState */.fE);
    const closeEvent = ()=>{
        document.body.style.overflow = "auto";
        setSelector(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBase/* default */.Z, {
        active: true,
        closeEvent: ()=>{
            document.body.style.overflow = "auto";
            updateTargetIndex(checkIndex);
            setSelector(false);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_OtherBankContents, {
            closeEvent: closeEvent
        })
    });
}
/* harmony default export */ var modal_OtherBankModal = (OtherBankModal);

// EXTERNAL MODULE: ./src/hooks/common/useReset.ts
var useReset = __webpack_require__(7822);
;// CONCATENATED MODULE: ./src/components/estimate/common/otherBank/area/OtherBankArea.tsx

function OtherBankArea_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  grid-column: span 6;\n"
    ]);
    OtherBankArea_templateObject = function() {
        return data;
    };
    return data;
}







const OtherBankArea_Base = emotion_styled_browser_esm/* default.section */.Z.section(OtherBankArea_templateObject());
/**
 *  타금융할부 모달 영역 컴포넌트
 *  */ function OtherBankArea() {
    // reset
    (0,useReset/* default */.Z)(modal_atom/* otherBankSelectorState */.Rl);
    // select
    const otherModal = (0,es/* useRecoilValue */.sJ)(modal_atom/* otherBankSelectorState */.Rl);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: otherModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherBankArea_Base, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_OtherBankModal, {})
        }) : null
    });
}
/* harmony default export */ var area_OtherBankArea = (OtherBankArea);


/***/ })

}]);